import { Tiptap } from "@/components/common/tiptap/Tiptap";
import Alert from "@/components/core/alert";
import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket";
import { Button } from "@/components/core/buttons/button";
import {
	Form,
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import Select from "@/components/core/forms/select";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { ScrollArea } from "@/components/core/scroller";
import { PdfViewer } from "@/components/pdf-viewer";
import { IconAlertCircle, IconTemplate, IconX } from "@tabler/icons-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

export default function InlineEditorModal() {
	const { closeModal } = useModalControl();
	const form = useForm({
		defaultValues: {
			type: "Show Preview",
			body: "",
		},
	});

	const showPreview = true;
	const showEditor = true;

	return (
		<div className="flex flex-col w-full h-full">
			<Form {...form}>
				<form className="w-full h-full">
					<div className="flex flex-col w-full h-full">
						<PanelGroup
							className="flex flex-row grow w-full h-full"
							direction="horizontal"
						>
							<Panel
								defaultSize={30}
								minSize={30}
								maxSize={30}
								className="flex flex-col h-full min-w-[420px] max-w-[420px]"
							>
								<div className="flex shrink-0 flex-row items-center justify-between w-full h-[50px] px-4 border-b border-slate-200">
									<span className="text-base font-bold text-foreground-dark">
										Inline Text Editor Modal
									</span>
									<button
										onClick={() => {
											closeModal();
										}}
										className="flex w-[20px] h-[20px] ring-offset-background transition-opacity outline-none border-none ring-0 text-foreground opacity-40 hover:opacity-100 disabled:pointer-events-none"
										type="button"
									>
										<IconX size={20} stroke={1.5} />
									</button>
								</div>

								<ScrollArea className="flex grow h-[calc(100svh - 120px)]">
									<div className="grid grid-cols-12 w-full p-4 gap-x-3 gap-y-2">
										<div className="col-span-12 w-full">
											<Alert
												type="info"
												allowClose={false}
												title="This Court Action has fees"
												icon={<IconAlertCircle size={20} stroke={2} />}
											/>
										</div>

										<div className="col-span-12 w-full">
											<FormField
												control={form.control}
												name="type"
												render={({ field }) => (
													<FormItem>
														<div className="flex flex-col w-full">
															<FormLabel required>Select Type</FormLabel>
														</div>
														<FormGroup>
															<Select
																options={[
																	{
																		value: "Show Editor",
																		label: "Show Editor",
																	},
																	{
																		value: "Show Preview",
																		label: "Show Preview",
																	},
																]}
															/>
														</FormGroup>
														<FormMessage />
													</FormItem>
												)}
											/>
										</div>
									</div>
								</ScrollArea>

								<div className="flex shrink-0 flex-row items-center w-full h-[70px] px-4 gap-2 mt-auto border-t border-slate-200">
									<Button
										className="w-full"
										variant="ghost"
										type="button"
										onClick={() => {
											closeModal();
										}}
									>
										Cancel
									</Button>
									<Button className="w-full">Submit</Button>
								</div>
							</Panel>

							<PanelResizeHandle className="group flex justify-center items-center w-[12px] border-r border-l border-border/50 bg-white">
								<div className="inline-flex w-[4px] h-[40px] rounded-sm bg-foreground/50 group-hover:bg-foreground/90" />
							</PanelResizeHandle>

							<Panel
								defaultSize={70}
								minSize={70}
								maxSize={70}
								className="flex flex-col shrink grow w-full h-full bg-slate-100"
							>
								{showPreview ? (
									<PdfViewer file="/case_complaint.pdf" />
								) : showEditor ? (
									<div className="flex flex-col w-full">
										<FormField
											control={form.control}
											name="body"
											render={({ field }) => (
												<FormItem>
													<FormGroup iconPosition="left">
														<Tiptap
															className="h-screen outline-0 border-none rounded-none"
															content={field.value}
															onUpdate={field.onChange}
														/>
													</FormGroup>
													<FormMessage />
												</FormItem>
											)}
										/>
									</div>
								) : (
									<Blanket className="my-auto self-center" width="sm">
										<BlanketImage
											icon={<IconTemplate size={24} stroke={1.5} />}
										/>
										<BlanketInfo
											title="No Selected Template"
											message="Select Template on Select Type to load the default template for this form."
										/>
									</Blanket>
								)}
							</Panel>
						</PanelGroup>
					</div>
				</form>
			</Form>
		</div>
	);
}
